import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid
} from '@mui/material';
import { GridColumn as Column } from '@progress/kendo-react-grid';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusIcon } from 'src/components/shared/DataGrid/BooleanCell';
import { DataGrid } from 'src/components/shared/DataGrid/DataGrid';
import { LoadingPanel } from 'src/components/shared/DataGrid/LoadingPanel';
import { Icon } from 'src/components/shared/Icon/Icon';
import { BodyType } from 'src/components/shared/Typography/BodyType';
import { LabelType } from 'src/components/shared/Typography/LabelType';
import { GradeDetailDto } from 'src/store/grades/grade';

interface Props {
  grades: GradeDetailDto[];
  loading: boolean;
  onGradeClick: (grade: GradeDetailDto) => void;
}

export const CorrectionsListMobile: React.FC<Props> = ({
  grades,
  loading,
  onGradeClick
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {loading && <LoadingPanel />}

      {grades.map(grade => (
        <Accordion key={grade.id}>
          <AccordionSummary
            onClick={() => onGradeClick(grade)}
            expandIcon={<Icon type="la-angle-down" />}
          >
            <Box display="flex" alignItems="center" width="100%">
              <Grid container spacing={0}>
                <Grid item xs={5}>
                  <LabelType>{t('grade.number')}</LabelType>
                  <BodyType>{grade.no}</BodyType>
                </Grid>
                <Grid item xs={6}>
                  <LabelType>{t('props.name')}</LabelType>
                  <BodyType>{grade.name}</BodyType>
                </Grid>
                <Grid item xs={1} className="flex align-center">
                  <StatusIcon type={grade.active ? 'la-check' : 'la-times'} />
                </Grid>
              </Grid>
            </Box>
          </AccordionSummary>
          <AccordionDetails style={{ display: 'block' }}>
            <Grid container spacing={0} className="mt-24 pr-48">
              <Grid item xs={11}>
                <LabelType>{t('props.description')}</LabelType>
                <BodyType>{grade.description}</BodyType>
              </Grid>
              <Grid item xs={1}>
                <LabelType>{t('props.internal')}</LabelType>
                <StatusIcon type={grade.internal ? 'la-check' : 'la-times'} />
              </Grid>
            </Grid>

            <DataGrid items={grade.gradeCorrections} className="mt-24">
              <Column field="parameter.name" title={t('parameter.singular')} />
              <Column
                field="instrument.name"
                title={t('instrument.singular')}
              />
              <Column
                field="correctionPart"
                title={t('grade.correctionPart')}
                filterable={false}
              />
            </DataGrid>
          </AccordionDetails>
        </Accordion>
      ))}
    </Fragment>
  );
};
